import React, {useState} from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import About from "./About";
import Experience from "./Experience";
import I18n, {Translator} from "./i18n";

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <Router>
            <div>
                <div className="bg-gray-900">
                    <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
                        <div className="relative flex grid items-center grid-cols-2 lg:grid-cols-3">
                            <ul className="flex items-center hidden space-x-8 lg:flex">
                                <li>
                                    <Link to="/"
                                          className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400"
                                    >
                                        <Translator path="header.who" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/projects"
                                          className="font-medium tracking-wide text-gray-100 transition-colors duration-200 hover:text-teal-accent-400"
                                    >
                                        <Translator path="header.projects" />
                                    </Link>
                                </li>
                            </ul>
                            <a
                                href="/"
                                aria-label="Edmar Espinola"
                                title="Edmar Espinola"
                                className="inline-flex items-center lg:mx-auto"
                            >
                                <span className="ml-2 text-xl font-bold tracking-wide text-gray-100 uppercase">
                  EDMAR ESPINOLA
                </span>
                            </a>
                            <div className="flex justify-end hidden lg:flex">
                                <I18n />
                            </div>
                            <div className="ml-auto lg:hidden">
                                <button
                                    aria-label="Open Menu"
                                    title="Open Menu"
                                    className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
                                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                                >
                                    <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                                        <path
                                            fill="currentColor"
                                            d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                                        />
                                        <path
                                            fill="currentColor"
                                            d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                                        />
                                        <path
                                            fill="currentColor"
                                            d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                                        />
                                    </svg>
                                </button>
                                {isMenuOpen && (
                                        <div
                                            className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
                                            role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                            <div className="py-1" role="none">
                                                <Link to="/"
                                                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                      onClick={() => setIsMenuOpen(!isMenuOpen)}
                                                >
                                                    <Translator path="header.who" />
                                                </Link>
                                                <Link to="/projects"
                                                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                      onClick={() => setIsMenuOpen(!isMenuOpen)}
                                                >
                                                    <Translator path="header.projects" />
                                                </Link>
                                                <div className="px-4 py-2">
                                                    <I18n />
                                                </div>
                                            </div>
                                        </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Switch>
                <Route exact path="/">
                    <About />
                </Route>
                <Route exact path="/projects">
                    <Experience />
                </Route>
            </Switch>
        </Router>
    );
}
export default Navbar;
